import React, { useRef } from 'react';
import { motion, useInView } from 'framer-motion';
export function ObjectionsSection() {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: true,
    margin: '-80px'
  });
  return <section className="w-full bg-warm py-16 md:py-24" ref={ref} data-id="element-104">
      <div className="max-w-prose mx-auto px-5" data-id="element-105">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={isInView ? {
        opacity: 1,
        y: 0
      } : {}} transition={{
        duration: 0.8
      }} data-id="element-106">
          <p className="font-sans text-xs tracking-[0.15em] uppercase text-sage mb-4" data-id="element-107">
            Tal vez estás pensando…
          </p>

          <h2 className="font-sans font-bold text-2xl md:text-3xl text-charcoal mb-10 leading-tight" data-id="element-108">
            Preguntas honestas, respuestas directas
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} animate={isInView ? {
        opacity: 1
      } : {}} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="space-y-8" data-id="element-109">
          {/* Objection 1 */}
          <div className="border-l-2 border-gold/40 pl-5 md:pl-6" data-id="element-110">
            <p className="font-sans font-semibold text-charcoal text-base md:text-lg mb-2 italic" data-id="element-111">
              «¿Y si soy de las que "todo le cae mal"?»
            </p>
            <p className="font-serif text-base md:text-lg text-charcoal/80 leading-[1.8]" data-id="element-112">
              Justo por eso el plan empieza limpiando variables. No te manda a
              probar 20 cosas. Te da un suelo estable.
            </p>
          </div>

          {/* Objection 2 */}
          <div className="border-l-2 border-gold/40 pl-5 md:pl-6" data-id="element-113">
            <p className="font-sans font-semibold text-charcoal text-base md:text-lg mb-2 italic" data-id="element-114">
              «No tengo tiempo.»
            </p>
            <p className="font-serif text-base md:text-lg text-charcoal/80 leading-[1.8]" data-id="element-115">
              Por eso son plantillas y prep de 60 minutos. No recetas eternas.
            </p>
          </div>

          {/* Objection 3 */}
          <div className="border-l-2 border-gold/40 pl-5 md:pl-6" data-id="element-116">
            <p className="font-sans font-semibold text-charcoal text-base md:text-lg mb-2 italic" data-id="element-117">
              «Ya intenté mil planes.»
            </p>
            <p className="font-serif text-base md:text-lg text-charcoal/80 leading-[1.8]" data-id="element-118">
              Este no es "otro plan". Es un sistema para que{' '}
              <strong data-id="element-119">dejes de adivinar.</strong>
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}